import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common.service';
import { FieldDefinition } from '../driver-import-interfaces';

interface DriverImportConfirmationDialogData {
  missingFields?: FieldDefinition[];
  invalidFields?: string[];
  errors?: string[];
  message: string;
  title: string;
  action: (command: string) => void;
  actionText: string;
  warningMessage: string;
  isWarning: boolean;
  showReturn: boolean;
}

@Component({
  selector: 'vrm-driver-import-confirmation',
  templateUrl: 'driver-import-confirmation.component.html',
  styleUrls: ['driver-import-confirmation.component.scss'],
})
export class DriverImportConfirmationComponent {
  public sMessage: string;
  public sTitle: string;
  public sAction: string;
  command: string;
  actionFromCaller: (command: string) => void;
  actionText: string;
  isWarning: boolean = false;
  warningMessage: string;
  showReturn: boolean;
  missingFields: FieldDefinition[];
  invalidFields: string[];
  errors: string[];
  constructor(
    public cService: CommonService,
    public dialogRef: MatDialogRef<DriverImportConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: DriverImportConfirmationDialogData
  ) {
    this.sTitle = dialogData.title;
    this.sMessage = dialogData.message;
    this.actionFromCaller = dialogData.action;
    this.actionText = dialogData.actionText;
    this.isWarning = dialogData.isWarning;
    this.invalidFields = dialogData.invalidFields;
    this.warningMessage = dialogData.warningMessage;
    this.showReturn = dialogData.showReturn;
    this.missingFields = dialogData.missingFields;
    this.errors = dialogData.errors;
  }

  doAction() {
    if (this.actionFromCaller) {
      this.actionFromCaller(this.command);
    }

    this.dialogRef.close();
  }
  doReturn() {
    this.dialogRef.close();
  }
}
